import script from "./TitleArrows.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleArrows.vue?vue&type=script&setup=true&lang=js"

import "./TitleArrows.vue?vue&type=style&index=0&id=627ef37b&lang=scss"

const __exports__ = script;

export default __exports__